

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import OpportunityTable from '../opportunity-table';

class OpportunityModal extends Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    const { show } = this.props;
    if (!show) {
      return null;
    }
    return (
      <OpportunityTable
        {...this.props.tableConfigs}
        stats={this.props.stats}
        enableFullScreen
        fullScreenMode
        onExitFullScreen={this.props.onClose}
        rememberControlStates={false}
      />
    );
  }
}


OpportunityModal.propTypes = {
  stats: PropTypes.arrayOf(PropTypes.shape({
    owner_id: PropTypes.string.isRequired,
  })).isRequired,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  tableConfigs: PropTypes.shape({}),
  getOpportunities: PropTypes.func,
};
OpportunityModal.defaultProps = {
  onClose: () => {},
  show: false,
  tableConfigs: {},
  getOpportunities: null,
};

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const { stats } = ownProps;
  return {
    show: stats.length > 0,
  };
}

export default connect(mapStateToProps)(OpportunityModal);
